import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {ButtonGhost, ButtonLink} from "../../_common/components/buttons/buttons";
import {t} from "../../_i18n";
import {connect} from "react-redux";

type Props = {
    id: string,
    history: any,
    handleDelete: any
}

class View extends Component<Props> {

    deleteOffer = () => {
        this.props.handleDelete()
    }

    cancelAction = () => {
        this.props.history.goBack()
    }

    render = ({id}: any) => <Modal id={id} className="md-no-fullscreen" title={t('¿Estas seguro que desea eliminar el borrador?')}>
        <div className='m-top m-x2-bottom'>
            <ButtonGhost className='danger sm-auto-width full-width' onClick={() => this.deleteOffer()}>
                {t('Eliminar')}
            </ButtonGhost>
            <ButtonLink className=' sm-auto-width full-width' onClick={() => this.cancelAction()}>
                {t('Cancelar')}
            </ButtonLink>
        </div>
    </Modal>
}

const ConnectedView: any = connect(
    ({}:any)=>({}), {})(View as any);


export default ({id, history, handleDelete}: any) =>
    <ConnectedView  id={id} history={history} handleDelete={handleDelete}/>
;
